module.exports = __webpack_public_path__ + "assets/img/ac1a7e23850807d38901a98867a435cd.svg";